<template>
  <div class="w-full md:w-1/2 lg:w-1/3 xl:w-1/4 p-6 flex flex-col">

  <ShowInOpenseaLink :tokenId="tokenId" />
    <div class="iframe1by1 shadow-lg hover:grow hover:shadow-lg">
      <iframe
        v-if="contentUri != ''"
        scrolling="no"
        sandbox="allow-same-origin allow-scripts"
        :src="httpUri(contentUri)"
      ></iframe>
    </div>

    

    <div class="pt-3">
      <a
        class="text-gray-800 block underline hover:text-gray-900"
        :href="httpUri(contentUri)"
        target="_blank"
        >{{ metadata.name }}</a
      >
      <small>Current edition: {{ edition }}</small>
      <p class="pt-1 text-gray-900">
        <button
          v-if="!pending"
          @click="claim"
          type="button"
          class="disabled:cursor-not-allowed inline-flex items-center px-4 py-2 border border-transparent rounded-md shadow-sm text-sm font-medium text-white bg-indigo-600 hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
          :disabled="!hasProvider"
        >
          Buy #{{ parseInt(edition) + 1 }}
          <span class="px-4 font-bold">Ξ {{ priceInEther }}</span>
        </button>

        <button
          v-else
          type="button"
          class="inline-flex items-center px-4 py-2 border border-transparent text-base leading-6 font-medium rounded-md text-white bg-indigo-600 hover:bg-indigo-700 focus:border-indigo-700 active:bg-indigo-700 transition ease-in-out duration-150 cursor-not-allowed"
          disabled=""
        >
          <svg
            class="animate-spin -ml-1 mr-3 h-5 w-5 text-white"
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
          >
            <circle
              class="opacity-25"
              cx="12"
              cy="12"
              r="10"
              stroke="currentColor"
              stroke-width="4"
            ></circle>
            <path
              class="opacity-75"
              fill="currentColor"
              d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
            ></path>
          </svg>
          Processing
        </button>
      </p>
    </div>
  </div>
</template>

<script>
import NftMixins from './mixins/NftMixins.js';


export default {
  name: "Nft",
  mixins:[NftMixins]

};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.iframe1by1 {
  position: relative;
  overflow: hidden;
  width: 100%;
  padding-top: 100%;

  touch-action: none;
  user-select: none;
  -webkit-user-select: none;
  -ms-user-select: none;
  -moz-user-select: none;
}

.iframe1by1 > iframe {
  border: none;
  position: absolute;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  width: 100%;
  height: 100%;

  touch-action: none;
  user-select: none;
  -webkit-user-select: none;
  -ms-user-select: none;
  -moz-user-select: none;
}

.hover\:grow {
  transition: all 0.3s;
  transform: scale(1);
}

.hover\:grow:hover {
  transform: scale(1.02);
}
</style>
